const tourSteps = {
  "marketplace": [
    {
      target: ".market-button-grid", // replace with a meaningful class
      content: "Explore cards for sale and trade. Filter or post yours here.",
    },
    {
      target: ".add-card-button",
      content: "Click here to add a new card to your marketplace listing.",
    },
    {
      target: ".marketplace-sort-options",
      content: "Sort cards by price, popularity, or newest listings.",
    },
  ],
  "createCard": [
    {
      target: ".create-card-form",
      content: "Start by filling in the key details for your card here.",
    },
    {
      target: ".card-upload-front",
      content: "Upload a clear image of your card's front.",
    },
    {
      target: ".card-upload-back",
      content: "Now upload the back side of your card.",
    },
    {
      target: ".submit-create-card",
      content: "Once you're ready, click here to create your card listing.",
    },
  ],
  "profile": [
    {
      target: ".user-info-section",
      content: "Here is your profile information. Update it as needed.",
    },
    {
      target: ".favorites-tab",
      content: "You can view and manage your favorite sellers and cards here.",
    },
    {
      target: ".report-button",
      content: "Flag suspicious users from here if needed.",
    },
  ],
};

export default tourSteps;
